<template>
  <section>
    <div class="header all-settlements">
      <p></p>
    </div>
    <data-table
      :contents="contents.settlements"
      :loading="contents.loading"
      :page-info="contents.pageInfo"
      :columns="columns"
      :handle-row-click="goToSettlement"
      :show-export="state.showExport"
      :handle-export-download="handleExportDownload"
      :title="contents.pageInfo.total + ' Settlement Batches'"
      primaryButtonName="Get Unsettled Transctions"
      :handlePrimaryButtonClick="handlePrimaryButtonClick"
      :showFilter="state.showFilter"
      :showFilterSlot="state.showFilter"
      :on-page-change="state.onPageChange"
      showTab
      :clear-filter="clearFilter"
      :paramsObject="{ type: 'retries' }"
    >
      <template v-slot:default="slotProps">
        <div class="filter" v-if="slotProps.openFilters">
          <Input
            label="Reference"
            :value="state.filter.settlement_reference"
            :onChange="(value) => (state.filter.settlement_reference = value)"
          />
          <Input
            label="Source Account"
            :value="state.filter.collection_nuban"
            :onChange="(value) => (state.filter.collection_nuban = value)"
          />
          <Input
            label="Destination Account"
            :value="state.filter.settlement_nuban"
            :onChange="(value) => (state.filter.settlement_nuban = value)"
          />
          <Input
            label="Merchant"
            :value="state.filter.merchant_name"
            :onChange="(value) => (state.filter.merchant_name = value)"
          />
          <Input
            label="Amount"
            :value="state.filter.amount"
            :onChange="(value) => (state.filter.amount = value)"
          />
          <Datepicker
            label="Initiation Date"
            :value="state.filter.settlement_date"
            :onDateSelected="
              (value) =>
                (state.filter.settlement_date = `${moment(value).format(
                  'YYYY-MM-DD'
                )}`)
            "
          />
          <Button
            buttonName="Apply Filter"
            :onClick="handleApplyFilter(slotProps)"
            classes="primary"
          />
        </div>
      </template>
      <template v-slot:tab>
        <Tab :tabs="state.tabs" />
      </template>
      <template v-slot:noContent>
        <EmptyState
          type="settlement"
          :url="handleRedirect"
          buttonText="Get Unsettled Transctions"
        />
      </template>
    </data-table>
  </section>
</template>
<script>
import { reactive, computed, onBeforeMount, watch } from "@vue/composition-api";
import dataTable from "@/components/dataTable.vue";
import NoContent from "@/components/noContent.vue";
import Tab from "@/components/tab.vue";
import Checkbox from "@/components/checkbox.vue";
import Input from "@/components/input.vue";
import Button from "@/components/button.vue";
import Datepicker from "@/components/datepicker.vue";
import { csvExport, pdfExport } from "@/lib/download";
import moment from "moment";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Settlements",
  },
  setup(props, { root }) {
    const store = root.$store;
    const query = root.$route.query;
    const columns = [
      { label: "Status", field: "STATUS" },
      { label: "REFERENCE", field: "REFERENCE" },
      {
        label: "INITIATION DATE",
        field: "INITIATION DATE",
        splitBy: "-",
        sortable: false,
      },
      { label: "SOURCE ACCOUNT", field: "SOURCE ACCOUNT", splitBy: "-" },
      {
        label: "DESTINATION ACCOUNT",
        field: "DESTINATION ACCOUNT",
        splitBy: "-",
      },
      { label: "MERCHANT", field: "MERCHANT" },
      { label: "AMOUNT", field: "AMOUNT", sortable: false },
    ];
    const state = reactive({
      title: "",
      tabs: [
        {
          url: "/dashboard/settlements/processed",
          name: "Processed",
        },
        {
          url: "/dashboard/settlements/pending",
          name: "Pending",
        },
      ],
      showFilter: true,
      showExport: true,
      filter: {
        settlement_reference: "",
        collection_nuban: "",
        settlement_nuban: "",
        merchant_name: "",
        amount: "",
        settlement_date: "",
      },
      appliedFilter: {},
      onPageChange: () => {},
      downloadType: null,
    });

    onBeforeMount(() => {
      store.dispatch("getSettlementList", {
        settlement_status: root.$route.params.type,
        ...root.$route.query,
      });
    });

    const contents = computed(() => store.getters.getSettlements);

    watch(
      () => root.$route.params,
      () => {
        store.dispatch("getSettlementList", {
          settlement_status: root.$route.params.type,
          ...root.$route.query,
        });
      }
    );

    watch(
      () => root.$route.query,
      () => {
        store.dispatch("getSettlementList", {
          settlement_status: root.$route.params.type,
          ...root.$route.query,
        });
      }
    );

    const handlePrimaryButtonClick = () => {
      root.$options.router.push({ name: "settlements-transactions" });
    };

    const handleRedirect = "/dashboard/settlements/transactions";

    const handleExportDownload = (type) => {
      store.dispatch("download", {
        filter: {
          ...state.appliedFilter,
          download: "true",
          settlement_status: root.$route.params.type,
          download_size: "100000",
          token: store.state.userDetails.token,
        },
        downloadType: type,
        url: "dashboard/admin/settlements",
        key: "settlements",
      });
    };

    const handleApplyFilter = (slotProps) => () => {
      slotProps.data.openFilters = false;
      state.appliedFilter = state.filter;

      store.dispatch("getSettlementList", {
        settlement_status: root.$route.params.type,
        ...state.filter,
      });
    };

    const clearFilter = () => {
      state.appliedFilter = {};
      state.filter = {
        settlement_ref: " ",
        collection_NUBAN: " ",
        settlement_NUBAN: " ",
        merchant_name: " ",
        amount: " ",
        settlement_date: " ",
      };

      store.dispatch("getSettlementList", {
        settlement_status: root.$route.params.type,
      });
    };

    const goToSettlement = (e) => {
      root.$options.router.push({
        name: "settlements-list-details",
        params: { id: e.row.id },
      });
    };

    return {
      columns,
      state,
      handlePrimaryButtonClick,
      handleExportDownload,
      contents,
      handleApplyFilter,
      clearFilter,
      moment,
      handleRedirect,
      goToSettlement,
    };
  },
  components: {
    // Table,
    dataTable,
    Checkbox,
    Input,
    Datepicker,
    Tab,
    Button,
    NoContent,
    EmptyState,
  },
  methods: {
    csvExport,
    pdfExport,
  },
};
</script>
<style lang="scss">
.all-settlements {
  padding: 30px 0 30px 25px;

  .table-component {
    min-width: 100%;
  }

  > p {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.1em;
    color: rgba(101, 93, 121, 0.7);
  }

  > div {
    display: flex;

    svg {
      cursor: pointer;
    }

    p {
      margin-left: 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 19px;
      color: #261940;
    }
  }
}

.filter {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 24px;

  .button-comp {
    margin-left: 20px;
    margin-bottom: 30px;
  }
}

.margin {
  margin: 0 30px;
}
</style>
